import { render, staticRenderFns } from "./CorrectRequestDialog.vue?vue&type=template&id=4552bce0&scoped=true"
import script from "./CorrectRequestDialog.vue?vue&type=script&lang=js"
export * from "./CorrectRequestDialog.vue?vue&type=script&lang=js"
import style0 from "./CorrectRequestDialog.vue?vue&type=style&index=0&id=4552bce0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4552bce0",
  null
  
)

export default component.exports